import { gql } from '@apollo/client';

export const GET_REGISTRATION_OFFICES = gql`
  query GetRegistrationOffices($input: FilterInstitutions!) {
    institutions: getRegistrationOffices(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          isInstitution
          isServiceProvider
          institution {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
      }
    }
  }
`;
